import {
  type ActionTree,
  type GetterTree,
  type Module,
  type MutationTree,
} from "vuex";
import { type RootState } from "../../root/store/state";
import { type DocumentState } from "./document-state";
const state: DocumentState = {
  clientId: 0 as number,
  selectedDocumentId: "" as string,
  showMakePublicDocumentDialog: false as boolean,
  showDocumentManage: true as boolean,
  isAdd: false as boolean,
  isDraggedOverImageCarousel: false as boolean, // only for disabling ondrag effect of document editor if an image is dragged on image carousel component.
  isSignalrGroupJoined: false as boolean,
  updatedDocumentIdsFromSignalR: [] as string[],
  showDocumentOverview: true as boolean,
  isFilled: false as boolean,
};
const getters: GetterTree<DocumentState, RootState> = {
  getSelectedDocumentId(state) {
    return state.selectedDocumentId;
  },
  getShowMakePublicDocumentDialog(state): boolean {
    return state.showMakePublicDocumentDialog;
  },
  getIsDraggedOverImageCarousel(state): boolean {
    return state.isDraggedOverImageCarousel;
  },
  showDocumentManage(state): boolean {
    return state.showDocumentManage;
  },
  isAdd(state): boolean {
    return state.isAdd;
  },
  getSignalrGroupJoined(state): boolean {
    return state.isSignalrGroupJoined;
  },
  getUpdatedDocumentIdArrayFromSignalR(state): string[] {
    return state.updatedDocumentIdsFromSignalR;
  },

  getShowDocumentOverview(state): boolean {
    return state.showDocumentOverview;
  },

  getDocumentIsFilledStatus(state): boolean {
    return state.isFilled;
  },
};
const mutations: MutationTree<DocumentState> = {
  SET_CLIENTFOCUS(state, value: number) {
    state.clientId = value;
  },
  SET_SELECTEDDOCUMENTID(state, value: string) {
    state.selectedDocumentId = value;
  },
  SET_SHOWMAKEPUBLICDOCUMENTDIALOG(state, value: boolean) {
    state.showMakePublicDocumentDialog = value;
  },
  SET_ISDRAGGEDOVERIMAGECAROUSEL(state, value: boolean) {
    state.isDraggedOverImageCarousel = value;
  },
  Set_DocumentManageVisibility(state, show: boolean) {
    state.showDocumentManage = show;
  },
  Set_isAddState(state, show: boolean) {
    state.isAdd = show;
  },
  SET_SIGNALRGROUPJOINED(state, value: boolean) {
    state.isSignalrGroupJoined = value;
  },
  SET_UPDATEDDOCUMENTIDARRAYFROMSIGNALR(state, value: string[]) {
    state.updatedDocumentIdsFromSignalR = value;
  },

  SET_SHOWDOCUMENTOVERVIEW(state, value: boolean) {
    state.showDocumentOverview = value;
  },

  SET_SETDOCUMENTISFILLEDSTATE(state, value: boolean) {
    state.isFilled = value;
  },
};
const actions: ActionTree<DocumentState, RootState> = {
  setClientFocus({ commit }, payload: any): any {
    return new Promise((resolve) => {
      commit("SET_CLIENTFOCUS", payload);
      resolve(payload);
    });
  },
  setSelectedDocumentId({ commit }, payload: string) {
    return new Promise((resolve) => {
      commit("SET_SELECTEDDOCUMENTID", payload);
      resolve(payload);
    });
  },
  setShowMakePublicDocumentDialog({ commit }, payload: boolean) {
    commit("SET_SHOWMAKEPUBLICDOCUMENTDIALOG", payload);
  },
  setIsDraggedOverImageCarouselComponent({ commit }, payload: boolean) {
    commit("SET_ISDRAGGEDOVERIMAGECAROUSEL", payload);
  },
  showDocumentManage({ commit }, payload: boolean) {
    commit("Set_DocumentManageVisibility", payload);
  },
  isAdd({ commit }, payload: boolean) {
    commit("Set_isAddState", payload);
  },
  setUpdatedDocumentIdArrayFromSignalR({ commit }, payload: string[]) {
    commit("SET_UPDATEDDOCUMENTIDARRAYFROMSIGNALR", payload);
  },
  setSignalrGroupJoined({ commit }, payload) {
    commit("SET_SIGNALRGROUPJOINED", payload);
  },
  setShowDocumentOverview({ commit }, payload: boolean) {
    commit("SET_SHOWDOCUMENTOVERVIEW", payload);
  },
  setDocumentIsFilledStatus({ commit }, payload) {
    commit("SET_SETDOCUMENTISFILLEDSTATE", payload);
  },
};
const namespaced: boolean = true;
export const documentModule: Module<DocumentState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
